<section>
  <app-style-guide-nav></app-style-guide-nav>

  <h3>Basic Buttons</h3>
  <div>
    <button mat-button>Basic</button>
    <button
      mat-button
      color="primary">
      Primary
    </button>
    <button
      mat-button
      color="accent">
      Accent
    </button>
    <button
      mat-button
      color="warn">
      Warn
    </button>
    <button
      mat-button
      disabled>
      Disabled
    </button>
    <a
      mat-button
      routerLink="."
      >Link</a
    >
  </div>

  <h3>Raised Buttons</h3>
  <div>
    <button mat-raised-button>Basic</button>
    <button
      mat-raised-button
      color="primary">
      Primary
    </button>
    <button
      mat-raised-button
      color="accent">
      Accent
    </button>
    <button
      mat-raised-button
      color="warn">
      Warn
    </button>
    <button
      mat-raised-button
      disabled>
      Disabled
    </button>
    <a
      mat-raised-button
      routerLink="."
      >Link</a
    >
  </div>

  <h3>Stroked Buttons</h3>
  <div>
    <button mat-stroked-button>Basic</button>
    <button
      mat-stroked-button
      color="primary">
      Primary
    </button>
    <button
      mat-stroked-button
      color="accent">
      Accent
    </button>
    <button
      mat-stroked-button
      color="warn">
      Warn
    </button>
    <button
      mat-stroked-button
      disabled>
      Disabled
    </button>
    <a
      mat-stroked-button
      routerLink="."
      >Link</a
    >
  </div>

  <h3>Flat Buttons</h3>
  <div>
    <button mat-flat-button>Basic</button>
    <button
      mat-flat-button
      color="primary">
      Primary
    </button>
    <button
      mat-flat-button
      color="accent">
      Accent
    </button>
    <button
      mat-flat-button
      color="warn">
      Warn
    </button>
    <button
      mat-flat-button
      disabled>
      Disabled
    </button>
    <a
      mat-flat-button
      routerLink="."
      >Link</a
    >
  </div>

  <h3>Icon Buttons</h3>
  <div>
    <button mat-icon-button>
      <mat-icon>favorite</mat-icon>
    </button>
    <button
      mat-icon-button
      color="primary">
      <mat-icon>favorite</mat-icon>
    </button>
    <button
      mat-icon-button
      color="accent">
      <mat-icon>favorite</mat-icon>
    </button>
    <button
      mat-icon-button
      color="warn">
      <mat-icon>favorite</mat-icon>
    </button>
    <button
      mat-icon-button
      disabled>
      <mat-icon>favorite</mat-icon>
    </button>
    <button mat-icon-button>
      <mat-icon>more_vert</mat-icon>
    </button>
    <button
      mat-icon-button
      color="primary">
      <mat-icon>home</mat-icon>
    </button>
    <button
      mat-icon-button
      color="accent">
      <mat-icon>menu</mat-icon>
    </button>
    <button
      mat-icon-button
      color="warn">
      <mat-icon>favorite</mat-icon>
    </button>
    <button
      mat-icon-button
      disabled>
      <mat-icon>open_in_new</mat-icon>
    </button>
  </div>

  <h3>Fab Buttons</h3>
  <div>
    <button mat-fab>Basic</button>
    <button
      mat-fab
      color="primary">
      Primary
    </button>
    <button
      mat-fab
      color="accent">
      Accent
    </button>
    <button
      mat-fab
      color="warn">
      Warn
    </button>
    <button
      mat-fab
      disabled>
      Disabled
    </button>
    <button mat-fab>
      <mat-icon>favorite</mat-icon>
    </button>
    <a
      mat-fab
      routerLink="."
      >Link</a
    >
    <button
      mat-fab
      color="primary">
      <mat-icon>delete</mat-icon>
    </button>
    <button
      mat-fab
      color="accent">
      <mat-icon>bookmark</mat-icon>
    </button>
    <button
      mat-fab
      color="warn">
      <mat-icon>home</mat-icon>
    </button>
    <button
      mat-fab
      disabled>
      <mat-icon>favorite</mat-icon>
    </button>
  </div>

  <h3>Mini Fab Buttons</h3>
  <div>
    <button mat-mini-fab>Basic</button>
    <button
      mat-mini-fab
      color="primary">
      Primary
    </button>
    <button
      mat-mini-fab
      color="accent">
      Accent
    </button>
    <button
      mat-mini-fab
      color="warn">
      Warn
    </button>
    <button
      mat-mini-fab
      disabled>
      Disabled
    </button>
    <button mat-mini-fab>
      <mat-icon>favorite</mat-icon>
    </button>
    <a
      mat-mini-fab
      routerLink="."
      >Link</a
    >
    <button
      mat-mini-fab
      color="primary">
      <mat-icon>menu</mat-icon>
    </button>
    <button
      mat-mini-fab
      color="accent">
      <mat-icon>plus_one</mat-icon>
    </button>
    <button
      mat-mini-fab
      color="warn">
      <mat-icon>filter_list</mat-icon>
    </button>
    <button
      mat-mini-fab
      disabled>
      <mat-icon>home</mat-icon>
    </button>
  </div>
</section>
